import _extends from 'babel-runtime/helpers/extends';

export default {
  props: {
    scenes: {
      type: Object,
      required: true
    },

    active: {
      type: String,
      default: 'start'
    }
  },

  data: function data() {
    return {};
  },


  computed: {
    innerScenes: function innerScenes() {
      var _this = this;

      var scenes = [{
        scene: 'start',
        image: '',
        name: this.$t('playTurbo.custom.previewer.scenes.start')
      }, {
        scene: 'ending',
        image: '',
        name: this.$t('playTurbo.custom.previewer.scenes.ending')
      }];

      return scenes.map(function (item) {
        return _extends({}, item, { image: _this.scenes[item.scene] });
      }).filter(function (item) {
        return !!item.image;
      });
    }
  }
};